import { QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Loader } from 'react-feather';
import { BrowserRouter, useNavigate } from 'react-router-dom';

import './index.css';
import LoginPage from './Login/LoginPage';
import reportWebVitals from './reportWebVitals';
import Router from './Router';
import AuthenticatedLayout from './shared/components/Layout/AuthenticatedLayout';
import { queryClient } from './shared/services/queryClient';
import { useAuthStore } from './shared/store/authStore';

const AuthHandler: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const handleAuthError = () => {
      navigate('/');
    };
    window.addEventListener('auth-error', handleAuthError);
    return () => {
      window.removeEventListener('auth-error', handleAuthError);
    };
  }, [navigate]);
  return null;
};

const AppContent: React.FC = () => {
  const { isAuthenticated, isInitialized, initialize } = useAuthStore();
  useEffect(() => {
    initialize();
  }, [initialize]);
  if (!isInitialized) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader className="h-8 w-8 animate-spin text-[#95699f]" />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <LoginPage />;
  }
  return (
    <AuthenticatedLayout>
      <Router />
    </AuthenticatedLayout>
  );
};

const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthHandler />
      <AppContent />
    </BrowserRouter>
  </QueryClientProvider>
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

reportWebVitals();
